import * as yup from 'yup';

export const simSwapValidationSchema = yup.object({
  reason: yup.string().required('common:validation.fieldRequired').default(''),
  simType: yup.string().required('common:validation.fieldRequired').default(''),
});

export type SimSwapFormValues = yup.InferType<typeof simSwapValidationSchema>;
